import type { CaptionProps } from "../../@types/viewerati";
import { mainCssRules } from "../../lib/cssTemplates";
import styled from "styled-components";

function opacityToHex(opacity: number) {
	const normalizedOpacity = opacity / 100;
	// Input validation
	if (normalizedOpacity < 0 || normalizedOpacity > 1) {
		throw new Error("Opacity must be between 0 and 1");
	}

	// Convert opacity to integer (0-255)
	const intOpacity = Math.round(normalizedOpacity * 255);

	// Convert integer to two-digit hex string with zero padding
	const hexOpacity = intOpacity.toString(16).padStart(2, "0").toUpperCase();

	return hexOpacity;
}

export const StyledCaption = styled.figcaption<CaptionProps & { $fontMultiplier?: number; $baseFontSizeRaw?: number }>`
  display: grid;
  height: auto;
  visibility: ${(props) => (props.$tapped ? "visible" : "hidden")};

  width: ${(props) => (props.$width ? `${props.$width}px` : "100%")};
  position: ${(props) => (props.$absolutePosition ? "absolute" : "relative")};
  ${(props) => props.$absolutePosition ? "bottom: 0;" : ""}
  ${(props) =>
		`${mainCssRules({
			baseFontSize: props.$baseFontSize,
			baseFontSizeRaw: props.$baseFontSizeRaw,
			fonts: props.theme.fonts,
			theme: props.theme,
			fontMultiplier: props.$fontMultiplier,
		})}`}
    background:${(props) =>
			props.$absolutePosition
				? props.theme.caption.background +
					opacityToHex(props.theme.caption.backdropOpacity)
				: "unset"};
    align-self: center;
  justify-items: ${(props) => props.theme.caption.align};
  font-size: 85%;
  margin-top: 0.3em;
  margin-bottom: 0;
`;
